import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
import { testimonials } from '../data/salesCopy';
export function Testimonials() {
  return <section className="bg-brand-sand px-4 py-8 sm:py-10" data-id="element-188" data-mp="3fze2zvj28zum">
      <div className="mx-auto max-w-4xl" data-id="element-189" data-mp="3fxumc3thsmsb">
        <SectionTitle data-id="element-190" data-mp="3b0udjl59d5xi">Ce que disent les professeurs</SectionTitle>

        <ul className="mt-5 grid grid-cols-1 gap-2.5 md:grid-cols-2" data-id="element-191" data-mp="3ayi1fom6lpsd">
          {testimonials.map((t, i) => <li key={t.name} className={`flex h-full flex-col rounded-lg bg-brand-ivory p-3.5 ${i === testimonials.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-192" data-mp="36wmqrtid201x" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 étoiles sur 5" data-id="element-193" data-mp="2s28cg69qretl">
                {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-194" data-mp="v8difd5cpw86" />)}
              </div>
              <p className="mt-2 text-[12.5px] font-medium italic leading-snug text-brand-brown/90 sm:text-[13.5px]" data-id="element-195" data-mp="h4n6uketiff5">
                “{t.quote}”
              </p>
              <div className="mt-auto pt-2.5" data-id="element-196" data-mp="78tvv5gqytzh">
                <p className="text-[12.5px] font-bold text-brand-brown" data-id="element-197" data-mp="7a4xaympzpnf">
                  {t.name}
                </p>
                <p className="text-[11.5px] font-medium text-brand-taupe" data-id="element-198" data-mp="zwpp2073y3ri">
                  {t.role} — {t.location}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}